/**
 * Centered state for a policy record tab (design OR-1639): featured icon,
 * title, description and an optional action. Every tab's "couldn't load"
 * and "nothing here" screens share this layout; each passes its own copy.
 */
import type { FC, ReactNode } from "react";
import { FeaturedIcon } from "@tricura/atlas-ui";

interface TabStateProps {
    icon: FC<{ className?: string }>;
    title: string;
    description: ReactNode;
    action?: ReactNode;
    "data-autotest"?: string;
}

export function TabState({ icon, title, description, action, "data-autotest": dataAutotest }: TabStateProps) {
    return (
        <div className="flex min-h-0 flex-1 flex-col items-center justify-center gap-4 px-6 py-16 text-center" data-autotest={dataAutotest}>
            <FeaturedIcon icon={icon} color="brand" theme="modern" size="lg" />
            <div className="flex max-w-sm flex-col gap-1">
                <h2 className="text-primary text-md font-semibold">{title}</h2>
                <p className="text-tertiary text-sm">{description}</p>
            </div>
            {action}
        </div>
    );
}
